module.exports = __webpack_public_path__ + "static/img/cont608.9f82b1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont608.jpg
// module id = 2EaC
// module chunks = 0